
<a class="gotopbtn leftConer wow fadeInDown" data-wow-duration="1.2s" data-wow-delay=".2s" *ngIf="showAppointment" data-aos="zoom-in" style="background-color: #FFD700;cursor:pointer;"> <i class="glyphicon glyphicon-chevron-up"></i> </a>
